export function getEffectSum(state, kind) {
    let sum = 0;
    for (const item of state.inventory) {
        if (item.passiveEffects) {
            for (const eff of item.passiveEffects) {
                if (eff.kind === kind)
                    sum += eff.value;
            }
        }
    }
    return sum;
}
export function getEffectMult(state, kind) {
    let mult = 1;
    for (const item of state.inventory) {
        if (item.passiveEffects) {
            for (const eff of item.passiveEffects) {
                if (eff.kind === kind)
                    mult *= eff.value;
            }
        }
    }
    return mult;
}
